import {DOMBindingResolver} from "../../lib/DOMBindingResolver.js";

import {Application} from "../../lib/Application.js";
import {ThemeLightDarkService} from "../ThemeLightDarkService.js";
import {SettingsRepository} from "../SettingsRepository.js";
import {themeSignal} from "../themeSignal.js";

const setTheme = function(theme) {
    if (theme === 'dark') {
        document.body.classList.add('dark');
        return;
    }
    document.body.classList.remove('dark');
}

/** @param {Application} app **/
export function initView(app) {

    DOMBindingResolver.handleAllResolveEvents(document.body, binding => {
        return app.resolve(binding);
    });

    app.bindSingleton(ThemeLightDarkService, () => {
        const settingsRepo = app.resolve(SettingsRepository);
        const service = new ThemeLightDarkService(settingsRepo);
        service.themeChanged.listen(theme => {
            setTheme(theme);
            themeSignal.set(theme);
        });
        return service;
    });

    window.addEventListener('app::location-changed', (evt) => {
        for(let layout of document.getElementsByTagName('x-header-nav')) {
            layout.currentLocation = evt.detail.pathname;
        }
    });

    window.addEventListener('app::theme-changed', (evt) => {
        app.resolve(ThemeLightDarkService).setConfiguredTheme(evt.detail);
    });

}